import { render, staticRenderFns } from "./SelectQualificacaoPropostas.vue?vue&type=template&id=060542ad"
import script from "./SelectQualificacaoPropostas.vue?vue&type=script&lang=js"
export * from "./SelectQualificacaoPropostas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports